import {FETCH_ALL,CREATE,UPDATE,DELETE,LIKE,FETCH_BY_SEARCH,START_LOADING,END_LOADING, FETCH_POST,COMMENT} from '../constants/actionTypes';


export default (state={isLoading:true , posts:[]},action) => {


    switch(action.type) {
        case START_LOADING:
            return {...state,isLoading:true}
        case END_LOADING:
            return {...state,isLoading:false}
        case UPDATE:
        case LIKE:
            return {...state,posts:state.posts.map((post)=>post._id===action.payload._id ? action.payload:post)};
        case FETCH_ALL:
        case FETCH_BY_SEARCH:
           // console.log(action.payload)
            return {...state,posts:action.payload.data,currentPage:action.payload.currentPage,totalPages:action.payload.totalPages};
        case FETCH_POST:
            return {...state,post:action.payload.post}
        case COMMENT:
            return {...state,posts:state.posts.map((post)=>{


                if(post._id === action.payload._id)
                    return action.payload;
                else
                    return post



            })}
        case DELETE:
            return {...state,posts:state.posts.filter((post)=>post._id !== action.payload)}
        case CREATE:
            return {...state,posts:[...state.posts , action.payload]};
        default:
            return state;


    }



}